import api from './api';

// MIGRATION: Removed independent agent routing logic
// All agents now use unified /payments endpoints
// Backend handles role-based filtering automatically

export const paymentsService = {
  // Get all payments
  getAll: async (params = {}) => {
    const response = await api.get('/payments', { params });
    return response.data;
  },

  // Request 2FA access to payment details
  requestPaymentAccess: async (paymentId, method = 'email') => {
    const response = await api.post(`/payments/${paymentId}/request-access`, { method });
    return response.data;
  },

  // Verify 2FA code and get payment details
  verifyPaymentAccess: async (paymentId, tempToken, code) => {
    const response = await api.post(`/payments/${paymentId}/verify-access`, {
      tempToken,
      code
    });
    return response.data;
  },

  // Get payment details (legacy method - now requires 2FA)
  getDetails: async (id, verificationHeaders = {}) => {
    const response = await api.get(`/payments/${id}/details`, {
      headers: verificationHeaders
    });
    return response.data;
  },

  // Process payment
  processPayment: async (paymentData) => {
    const response = await api.post('/payments', paymentData);
    return response.data;
  },

  // Update payment status
  updateStatus: async (id, status, notes) => {
    const response = await api.put(`/payments/${id}/status`, { status, notes });
    return response.data;
  },

  // Delete payment
  deletePayment: async (id) => {
    const response = await api.delete(`/payments/${id}`);
    return response.data;
  }
};
